import { StrictMode, useEffect } from "react";
import ReactDOM from "react-dom";
import AOS from "aos";

import { CacheWrapper, EmotionCacheProvider } from './components/core/providers/EmotionCacheManager';

import AppMain from "./components/AppMain";

const App = () => {

    useEffect(() => {
        AOS.init({
            delay: 200, // values from 0 to 3000, with step 50ms
            duration: 1000,
            once: true,
            disable: navigator.userAgent.toLowerCase().indexOf('prerender') !== -1
        });
        window.AOS = AOS;
    }, []);

    return (
        <StrictMode>
            <EmotionCacheProvider>
                <CacheWrapper>
                    <AppMain />
                </CacheWrapper>
            </EmotionCacheProvider>
        </StrictMode>
    );
}

export default App;

// only bootstrap on browser
(() => {
  process.env.NODE_ENV !== "test" && //eslint-disable-line no-undef
    ReactDOM.render(<App />, document.getElementById("app"));
})();
